import {createSlice} from '@reduxjs/toolkit'
import {LocalStorage} from '../util/localStorage'
import {SearchScope, searchScopesMock} from './models/SearchScope'
import {userAPI} from '../user/rtkUserApi'

export type HeaderStateType = {
    searchScopes: SearchScope[],
    drawerOpen: boolean

}

const initialState: HeaderStateType = {
    searchScopes: searchScopesMock,
    drawerOpen: false
}

const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setDrawerOpen(state: HeaderStateType, action) {
            state.drawerOpen = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            //React to a call to getUser
            .addMatcher(userAPI.endpoints.getUser.matchFulfilled, (state:HeaderStateType, action) => {
                LocalStorage.setUserEmail(action.payload?.email ?? '')
            })
    },
})

export const { setDrawerOpen } = headerSlice.actions

export default headerSlice.reducer
